import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { FuncionService } from '../../servicios/funcion.service';
import { PhoneNumber } from '../../utilidades/utilidades';
import { environment } from '../../../environments/environment.prod';

@Component({
	selector: 'app-mi-cuenta',
	templateUrl: './mi-cuenta.component.html',
	styleUrls: ['./mi-cuenta.component.css']
})
export class MiCuentaComponent implements OnInit {

	phoneNumber = new PhoneNumber();

	listaStates:any = [{
		id:1,
		titulo:"Datos personales",
		icono:"<i class='far fa-user'></i>"
	},{
		id:2,
		titulo:"Direcciones de envío",
		icono:"<i class='fas fa-map-marker-alt'></i>"
	},{
		id:3,
		titulo:"Lista de pedidos",
		icono:"<i class='fas fa-receipt'></i>"
	},{
		id:4,
		titulo:"Mi Wishlist",
		icono:` <span class="fa-stack">
		<i class="far fa-bookmark fa-stack-2x"></i>
		<i class="far fa-heart fa-stack-1x"></i>
		</span>`
	}];

	newSeguridad:any = {
		password:"",
		confirmacion:""
	};

	showSecurity:boolean = false;
	editarDatos:boolean = false;
	registrarDireccion:boolean = false;

	newState:any = {};
	newCliente:any = {};
	currentCliente:any = {};

	responseColonias:any = [];
	listaDirecciones:any = [];
	newDireccion:any = { id:0 };
	listaColonias:any = [];

	showClave:boolean = false;
	showConfirm:boolean = false;


	listaFavoritos:any[] = [];
	listaPedidos:any[] = [];

	totalProductos:number;
	paginacion:any = {
		max:5, offset:0, incio:0, fin:0, totalPaginas:0
	}

	leyenda:string = "";
	menuPedidos:any[] = [];

	constructor(
		private newActivatedRoute: ActivatedRoute, 
		private newRouter: Router,
		private newTitle: Title,
		private newFuncionService: FuncionService
		) { }

	fnInitMenu(){
		this.menuPedidos = [{
			id:1,
			active:true,
			leyenda:"Lo sentimos no has realizado ningun pedido.",
			nombre:"Todos los pedidos",
			icono:"<i class='fas fa-layer-group'></i>"
		},{
			id:2,
			active:false,
			leyenda:"Lo sentimos no hay pedidos pendientes.",
			nombre:"Pedidos pendientes",
			icono:"<i class='fas fa-shipping-fast'></i>"
		},{
			id:3,
			active:false,
			leyenda:"Lo sentimos no tienes pedidos entregados.",
			nombre:"Pedidos entregados",
			icono:"<i class='far fa-handshake'></i>"
		},{
			id:4,
			active:false,
			leyenda:"Lo sentimos no tienes pedidos cancelados o devueltos.",
			nombre:"Otros pedidos",
			icono:`<span class="fa-stack">
					<i class="fas fa-retweet fa-stack-1x"></i>
			  		<i class="fas fa-ban fa-stack-2x" style="color:Tomato"></i>
			  	</span>`
		}];
	};

	ngOnInit(): void {
		this.newFuncionService.fnInformacionCliente( this.newFuncionService.currentUserValue );

		this.newActivatedRoute.data.subscribe( (response:any) =>{
			this.fnCambiarState( this.listaStates.find( newItem => newItem.id === response.action ) );

			if( this.newState.id === 1 ){
				this.newTitle.setTitle("Mi cuenta");
				this.fnCargarDatosPersonales();
			}else if( this.newState.id === 2 ){
				this.newTitle.setTitle("Mis direcciones");
				this.fnCancelarDireccion();
				this.fnCargarDireccionesEnvio();
			}else if( this.newState.id === 3 ){
				this.newTitle.setTitle("Mis pedidos");
				this.paginacion = { max:3, offset:0, incio:0, fin:0, totalPaginas:0, tipo:1 };
				this.fnInitMenu();
				this.fnPaginarPedidos();
			}else if( this.newState.id === 4 ){
				this.newTitle.setTitle("Mis favoritos");
				this.paginacion = { max:5, offset:0, incio:0, fin:0, totalPaginas:0 };
				this.fnCargarWishList();
			}
		});

	}

	fnCambiarState( newItem ){
		this.newState = newItem;
		if( newItem.id === 1 ){
			this.newRouter.navigate(['mi-cuenta']);
		}else if( newItem.id === 2 ){
			this.newRouter.navigate(['mi-cuenta', 'mis-direcciones']);
		}else if( newItem.id === 3 ){
			this.newRouter.navigate(['mi-cuenta', 'mis-pedidos']);
		}else if( newItem.id === 4 ){
			this.newRouter.navigate(['mi-cuenta', 'mis-favoritos']);
		}
	};

	fnInitEdicion( newEstatus ){
		this.newCliente = {
			nombre:this.currentCliente.nombre,
			paterno:this.currentCliente.paterno,
			materno:this.currentCliente.materno,
			telefono:this.currentCliente.telefono
		};
		this.editarDatos = newEstatus;

		this.newSeguridad = {
			password:"",
			confirmacion:""
		};
		this.showClave = false;
		this.showConfirm = false;
		this.showSecurity = false;
	}


	fnCargarDatosPersonales(){
		this.newFuncionService.setNewMensaje("Cargando tus datos personales...");
		this.newFuncionService.fnCargarDatosPersonales().subscribe( (response:any) =>{
			this.newFuncionService.setNewMensaje(null);
			if( response.success ){
				this.currentCliente = response.informacion;
			}
		});
	}

	fnActualizarDatosPersonales(){
		var detalle = "";
		if( this.newCliente.nombre === "" ){
			detalle += "<br>No has ingresado tu nombre.";
		}
		if( this.newCliente.paterno === "" ){
			detalle += "<br>No has ingresado tu apellido paterno.";
		}
		if( this.newCliente.materno === "" ){
			detalle += "<br>No has ingresado tu apellido materno.";
		}
		if( this.newCliente.telefono === "" ){
			detalle += "<br>No has ingresado tu teléfono.";
		}

		if( detalle != "" ){
			environment.alerta.cuenta.datos
			var newMensaje = environment.alerta.cuenta.datos.mensaje;
			newMensaje = newMensaje.replace("#detalle#", detalle);
			this.newFuncionService.setNewAlerta({
				mensaje: newMensaje,
				titulo:environment.alerta.cuenta.datos.titulo,
				estilo:environment.alerta.cuenta.datos.estilo,
				icono:environment.alerta.cuenta.datos.icono
			});
		}else{
			this.newFuncionService.setNewMensaje("Actualizando tus datos personales...");
			this.newFuncionService.fnActualizarDatosPersonales( this.newCliente ).subscribe( (response:any) =>{
				this.newFuncionService.setNewMensaje(null);
				if( response.success ){
					this.fnInitEdicion( false );
					this.fnCargarDatosPersonales();
				}
			});
		}
	}

	fnActualizarClave(){
		var detalle = "";
		if( this.newSeguridad.password === "" ){
			detalle += "<br>No has ingresado la nueva contraseña.";
		}
		if( this.newSeguridad.confirmacion === "" ){
			detalle += "<br>No has ingresado la confirmación de la nueva contraseña.";
		}
		if( detalle === "" ){
			if( this.newSeguridad.password !== this.newSeguridad.confirmacion ){
				detalle += "<br>Las contraseñas ingresadas no coinciden.";
			}
		}
		if( detalle != "" ){
			environment.alerta.cuenta.datos
			var newMensaje = environment.alerta.cuenta.datos.mensaje;
			newMensaje = newMensaje.replace("#detalle#", detalle);
			this.newFuncionService.setNewAlerta({
				mensaje: newMensaje,
				titulo:environment.alerta.cuenta.datos.titulo,
				estilo:environment.alerta.cuenta.datos.estilo,
				icono:environment.alerta.cuenta.datos.icono
			});
		}else{
			this.newFuncionService.setNewMensaje("Actualizando tu clave de acceso...");
			this.newFuncionService.fnCambiarClave( this.newSeguridad ).subscribe( (response:any) =>{
				this.newFuncionService.setNewMensaje(null);
				if( response.success ){
					this.fnInitEdicion( false );
				}
			});
		}
	}

	telInputObject(obj) {
		obj.setCountry('mx');
		obj.setNumber(this.newCliente.telefono);
	}

	hasError( newEvent ){
		if( !newEvent ){
			this.newFuncionService.setNewAlerta( environment.alerta.registro.telefono.formato );
		}
	}

	getNumber( newEvent ){
		this.newCliente.telefono = newEvent;
	}

	onCountryChange( newEvent ){ };



	fnCargarDireccionesEnvio(){
		this.newFuncionService.setNewMensaje("Cargando direcciones de envío");
		this.newFuncionService.fnCargarDireccionesEnvio().subscribe( (response:any) =>{
			this.newFuncionService.setNewMensaje(null);
			if( response.success ){
				this.listaDirecciones = response.direcciones;
			}
		});
	}

	fnSeleccionDireccion( newDireccion ){
		this.newDireccion = newDireccion.direccion;
		setTimeout( ()=>{
			this.fnCargarColonias();
			this.registrarDireccion = true;
		}, 100);
	}

	fnCancelarDireccion(){
		this.newDireccion = { id:0 };
		this.registrarDireccion = false;
	}

	fnSeleccionColonia( newEvent ){
		var newSeleccion = this.responseColonias.colonias.find( newItem => newItem.id === newEvent.id )
		this.newDireccion.municipio = this.responseColonias.municipio;
		this.newDireccion.estado = this.responseColonias.estado;
		this.newDireccion.pais = this.responseColonias.pais;
		this.newDireccion.ciudad = this.responseColonias.ciudad;
		this.newDireccion.colonia = newEvent;
	}

	fnInitDireccion(){
		this.newDireccion = {
			id:0, calle:"", exterior:"", interior:"",
			codigoPostal:"", colonia:{id:0},municipio:"", estado:"",
			pais:"", referencia:""
		};
		this.listaColonias = [];
		this.registrarDireccion = true;
	};

	fnActualizarDireccionEnvio( ){
		var detalle = "";
		if( this.newDireccion.calle === "" ){
			detalle += "<br>No has ingresado el nombre de la calle.";
		}
		if( this.newDireccion.codigoPostal === "" ){
			detalle += "<br>No has ingresado el código postal.";
		}else if( !environment.validacion.codigoPostal.test( this.newDireccion.codigoPostal ) ){
			detalle += "<br>El código postal ingresado no tiene el formato correcto.";
		}
		if( this.newDireccion.colonia.id === 0 ){
			detalle += "<br>No has seleccionado una colonia.";
		}
		if( this.newDireccion.referencia === "" ){
			detalle += "<br>No has ingresado una referencia.";
		}

		if( detalle != "" ){
			environment.alerta.cuenta.datos
			var newMensaje = environment.alerta.cuenta.direccion.mensaje;
			newMensaje = newMensaje.replace("#detalle#", detalle);
			this.newFuncionService.setNewAlerta({
				mensaje: newMensaje,
				titulo:environment.alerta.cuenta.datos.titulo,
				estilo:environment.alerta.cuenta.datos.estilo,
				icono:environment.alerta.cuenta.datos.icono
			});
		}else{
			this.newFuncionService.setNewMensaje("Registrando datos de la dirección de envío...");
			this.newFuncionService.fnActualizarDireccionEnvio( {direccion:this.newDireccion} ).subscribe( (response:any) =>{
				this.newFuncionService.setNewMensaje(null);
				if( response.success ){
					this.registrarDireccion = false;
					this.fnCargarDireccionesEnvio();
				}
			});
		}
	}


	fnCargarColonias(){
		if( environment.validacion.codigoPostal.test( this.newDireccion.codigoPostal ) ){
			this.newFuncionService.setNewMensaje("Buscando colonias del código postal...");
			this.newFuncionService.fnBuscarColonias( { colonia:{ codigoPostal: this.newDireccion.codigoPostal  }} )
			.subscribe( (response:any) =>{
				this.newFuncionService.setNewMensaje(null);
				if( response.success ){
					this.listaColonias = [];
					this.responseColonias = response.data;
					response.data.colonias.forEach( (newItem:any) =>{
						this.listaColonias.push( {id:newItem.id, nombre:newItem.colonia} );
					});
					this.listaColonias = this.newFuncionService.fnOrdenarLista(this.listaColonias, "nombre");
				}
			});
		}else{
			if( this.newDireccion.codigoPostal !== "" ){
				this.newFuncionService.setNewAlerta( environment.alerta.direccion.codigoPostal.formato );
			}
		}
	};

	fnEliminarDireccionEnvio( newDireccion ){
		this.newFuncionService.setNewMensaje("Eliminando dirección de envío...");
		this.newFuncionService.fnEliminarDireccionEnvio( {direccion:{id:newDireccion.direccion.id}} ).subscribe( (response:any) =>{
			this.newFuncionService.setNewMensaje(null);
			if( response.success ){
				this.fnCargarDireccionesEnvio();
			}
		});
	}

	fnCargarWishList(){
		this.newFuncionService.setNewMensaje("Cargando tus productos favoritos ...");
		this.newFuncionService.fnCargarWishList( this.paginacion ).subscribe( (response:any) =>{
			this.newFuncionService.setNewMensaje(null);
			if( response.success ){
				this.listaFavoritos = response.lista;
				this.totalProductos = response.total;

				this.paginacion.inicio = ( this.paginacion.offset + 1 );
				this.paginacion.fin = ( this.paginacion.offset + this.listaFavoritos.length );
				this.paginacion.totalPaginas = Math.ceil(this.totalProductos / this.paginacion.max);
			}
		});
	}


	fnPaginarProductos( newPagina ){
		if( parseInt(newPagina) === 1 ){
			this.paginacion.offset = 0;
		}else{
			this.paginacion.offset = ( this.paginacion.max * ( newPagina - 1 ));
		}

		if( this.newState.id === 1 ){
			// this.fnCargarDatosPersonales();
		}else if( this.newState.id === 2 ){
			// this.fnCargarDireccionesEnvio();
		}else if( this.newState.id === 3 ){
			this.fnPaginarPedidos();
		}else if( this.newState.id === 4 ){
			this.fnCargarWishList();
		}
	}

	fnErrorPaginador( newError ){
		this.newFuncionService.setNewAlerta( newError );
	}

	fnPaginarPedidos(){
		this.listaPedidos = [];
		this.newFuncionService.setNewMensaje("Cargando tus pedidos ...");
		this.newFuncionService.fnCargarPedidos( this.paginacion ).subscribe( (response:any) =>{
			this.newFuncionService.setNewMensaje(null);
			if( response.success ){
				this.listaPedidos = response.lista;
				this.totalProductos = response.total;

				this.paginacion.inicio = ( this.paginacion.offset + 1 );
				this.paginacion.fin = ( this.paginacion.offset + this.listaPedidos.length );
				this.paginacion.totalPaginas = Math.ceil(this.totalProductos / this.paginacion.max);
			}
		});
	}

	fnClassPedido( newPeiddo ){
		if( newPeiddo.tipo === 1 ){
			return "pedido-pendiente"
		}else if( newPeiddo.tipo === 2 ){
			return "pedido-entregado"
		}else if( newPeiddo.tipo === 3 ){
			return "pedido-cancelado"
		}
	}

	fnCambiarPedidos( newMenu ){
		this.paginacion = { max:3, offset:0, incio:0, fin:0, totalPaginas:0, tipo:1 };
		this.menuPedidos.forEach(function( newItem ){
			newItem.active = false;
		});
		this.leyenda = newMenu.leyenda;
		newMenu.active = true;
		this.paginacion.tipo = newMenu.id;
		this.fnPaginarPedidos();
	}

	fnMostrarDetallePedido( newPedido ){
		this.newRouter.navigate(['mi-cuenta', 'pedido', newPedido.uuid]);
	}

}
